import React from 'react';
import { adjustTime } from '../../../utils/timeUtils';

export interface TimeControlProps {
    value: string;
    onChange: (val: string) => void;
}

export const TimeControl: React.FC<TimeControlProps> = ({ value, onChange }) => {
    const safeValue = value || '00:00:00';
    const parts = safeValue.split(':');

    const ArrowBtn = ({ dir, onClick }: { dir: 'up' | 'down', onClick: () => void }) => (
        <button
            onClick={onClick}
            style={{
                background: 'transparent',
                border: 'none',
                color: 'var(--color-text-muted)',
                cursor: 'pointer',
                padding: '2px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                transition: 'color 0.2s'
            }}
            onMouseEnter={e => e.currentTarget.style.color = 'var(--color-accent-danger)'}
            onMouseLeave={e => e.currentTarget.style.color = 'var(--color-text-muted)'}
        >
            <svg width="10" height="6" viewBox="0 0 10 6" fill="currentColor" style={{ display: 'block' }}>
                {dir === 'up' ? <path d="M5 0L10 6H0L5 0Z" /> : <path d="M5 6L0 0H10L5 6Z" />}
            </svg>
        </button>
    );

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            background: 'var(--color-input-bg)',
            padding: '4px 8px',
            borderRadius: 'var(--border-radius-sm)',
            border: '1px solid var(--color-panel-border)',
            boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.5)'
        }}>
            {['h', 'm', 's'].map((unit, i) => (
                <React.Fragment key={unit}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '32px' }}>
                        <ArrowBtn dir="up" onClick={() => onChange(adjustTime(safeValue, 1, unit as any))} />
                        <span style={{
                            fontFamily: "var(--font-mono)",
                            color: 'var(--color-text-primary)',
                            fontSize: '1rem',
                            fontWeight: '700',
                            marginTop: '2px',
                            marginBottom: '2px',
                        }}>
                            {parts[i] || '00'}
                        </span>
                        <ArrowBtn dir="down" onClick={() => onChange(adjustTime(safeValue, -1, unit as any))} />
                    </div>
                    {i < 2 && <span style={{ color: 'var(--color-panel-border)', fontSize: '1rem', fontWeight: 'bold' }}>:</span>}
                </React.Fragment>
            ))}
        </div>
    );
};
